<a class="skip-link" href="#main-content" (click)="skipToMain($event)">
  {{ 'COMMON.ACTION.SKIP_TO_MAIN_CONTENT' | translate }}
</a>

<div class="layout-wrapper" *ngIf="myself$ | async">
  <!------------------------->
  <!-- DESKTOP LEFT COLUMN -->
  <!------------------------->

  <div *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'; else MobileBlock" class="column column-left">
    <div class="logo-container">
      <app-company-logo (logoClicked)="logoClicked()"></app-company-logo>
    </div>
    <ng-container *ngIf="(myProcesses$ | async)?.length > 0">
      <app-application-selector
        class="application-selector-container"
        [myProcesses$]="myProcesses$"
        [myProcess]="myProcess"
        [addingNewProcess]="addingNewProcess"
        [myself$]="myself$"
        (applicationChanged)="applicationChanged($event)">
      </app-application-selector>
    </ng-container>
    <div
      class="margin-setter"
      *ngIf="!isForeigner || (isForeigner && !!(myProcesses$ | async)?.length === false)"></div>
    <app-sidebar-menu
      class="menu-items-container"
      [sideMenuItems]="sideMenuItems"
      [isForeigner]="isForeigner"
      [myProcess]="myProcess"
      [addingNewProcess]="addingNewProcess">
    </app-sidebar-menu>

    <div
      [@slideInOut]
      *ngIf="allowedToParticipateInPartnerProgram && seenArticlesHint"
      (click)="openMyPartnerAccountDrawer()"
      class="partner-account-promo-container">
      <span class="gift-icon" nz-icon nzType="gift" nzTheme="outline"></span>
      <span class="promo-text" [translate]="'PARTNER_ACCOUNT.GIVE_AND_EARN'"></span>
    </div>
  </div>

  <!------------------------>
  <!-- MOBILE LEFT COLUMN -->
  <!------------------------>

  <ng-template #MobileBlock>
    <nz-drawer
      [nzClosable]="false"
      [nzVisible]="showSidebar"
      [nzPlacement]="'left'"
      [nzWidth]="sidebarWidth"
      [nzBodyStyle]="{
        padding: '0'
      }"
      (nzVisibleChange)="onDrawerVisibilityChange($event)"
      (nzOnClose)="toggleSidebar()">
      <ng-container *nzDrawerContent>
        <div
          class="column column-left"
          appSwipe
          tabindex="-1"
          #drawerFocus
          role="dialog"
          (swipeLeft)="toggleSidebar()"
          [attr.aria-modal]="true"
          [attr.aria-labelledby]="'sidebar-title'">
          <h2 id="sidebar-title" class="sr-only">
            {{ 'COMMON.LAYOUT.SIDEBAR' | translate }}
          </h2>

          <button id="close-button-container_left" mat-icon-button (click)="toggleSidebar()">
            <mat-icon>menu</mat-icon>
          </button>

          <div class="utils-buttons-wrapper">
            <app-utils-buttons [theme]="'LIGHT'"></app-utils-buttons>
          </div>

          <ng-container *ngIf="(myProcesses$ | async)?.length > 0">
            <app-application-selector
              class="application-selector-container"
              [myProcesses$]="myProcesses$"
              [myProcess]="myProcess"
              [addingNewProcess]="addingNewProcess"
              [myself$]="myself$"
              (applicationChanged)="applicationChanged($event)">
            </app-application-selector>
          </ng-container>

          <app-sidebar-menu
            class="menu-items-container"
            [sideMenuItems]="sideMenuItems"
            [isForeigner]="isForeigner"
            [myProcess]="myProcess"
            [addingNewProcess]="addingNewProcess">
          </app-sidebar-menu>

          <div
            *ngIf="allowedToParticipateInPartnerProgram"
            (click)="openMyPartnerAccountDrawer()"
            class="partner-account-promo-container">
            <span class="gift-icon" nz-icon nzType="gift" nzTheme="outline"></span>
            <span class="promo-text" [translate]="'PARTNER_ACCOUNT.GIVE_AND_EARN'"></span>
          </div>
        </div>
      </ng-container>
    </nz-drawer>
  </ng-template>

  <!------------------>
  <!-- RIGHT COLUMN -->
  <!------------------>

  <div class="column column-right">
    <div class="shout-container" *ngIf="(maintenanceInfo$ | async)?.maintenanceUpcoming">
      <div
        class="shout-message"
        *ngIf="(maintenanceInfo$ | async)?.message as message"
        [innerHTML]="message[currentLang]"></div>
    </div>

    <div class="topbar" [class.has-progress-bar]="showProgressBar" [class.has-shadow]="showTopbarShadow">
      <div class="row">
        <button
          *ngIf="deviceInfo.deviceTypeDetected !== 'DESKTOP'"
          id="close-button-container_right"
          mat-icon-button
          (click)="toggleSidebar()">
          <mat-icon>menu</mat-icon>
        </button>
        <div *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'" class="utils-buttons-wrapper">
          <app-utils-buttons></app-utils-buttons>
        </div>
        <div *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP' && showProgressBar" class="percentages-container">
          <div
            matTooltip="{{ 'COMMON.LAYOUT.COMPLETION_PERCENTAGE' | translate }}"
            matTooltipClass="personalDataFormTooltip">
            <span class="progress-percent-text">{{ progressPercentage }} %</span>
          </div>
        </div>
        <div class="menu-buttons">
          <!-- Admins Settings - Only for administrators buttons -->
          <button
            *ngIf="isAdministrator"
            mat-button
            [routerLink]="['/administration/system-settings']"
            [attr.aria-label]="'COMMON.LAYOUT.SYSTEM_SETTINGS' | translate">
            <mat-icon fontSet="material-icons-outlined">construction</mat-icon>
          </button>
          <!-- Admins buttons END -->

          <!-- Guide -->
          <button
            *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP' && isForeigner"
            mat-button
            disableRipple
            [matMenuTriggerFor]="helpmenu"
            class="open-help-button"
            aria-haspopup="menu"
            aria-controls="helpmenu"
            [attr.aria-label]="'COMMON.LAYOUT.GUIDE' | translate">
            <mat-icon fontSet="material-icons-outlined">question_mark</mat-icon>
          </button>

          <mat-menu #helpmenu="matMenu" id="helpmenu">
            <button mat-menu-item (click)="openGuide(GUIDE_NAME.FIRST_TIME)" *ngIf="isForeigner">
              <mat-icon class="regular-text-color" fontSet="material-icons-outlined">live_help</mat-icon>
              {{ 'GUIDE.RESTART_GLOBAL_GUIDE' | translate }}
            </button>
          </mat-menu>

          <!-- Notifications -->
          <button
            mat-button
            (click)="toggleNotificationsWindow()"
            class="open-notifications-button"
            [class.has-unread-notifications]="unreadNotificationsCount > 0"
            [class.received-notification]="newNotificationReceived"
            [attr.aria-label]="'COMMON.LAYOUT.NOTIFICATIONS' | translate"
            [attr.aria-expanded]="showNotifications"
            [attr.aria-haspopup]="'dialog'"
            [attr.aria-controls]="'notifications-panel'">
            <mat-icon
              class="open-notifications-icon"
              [matBadgeHidden]="unreadNotificationsCount === 0"
              matBadgePosition="before"
              matBadgeSize="medium"
              [matBadgeColor]="'warn'"
              fontSet="material-icons-outlined"
              [matBadge]="unreadNotificationsCount"
              >notifications
            </mat-icon>
          </button>

          <!-- Top Bar Menu -->
          <button
            mat-button
            (click)="toggleTopbarMenu()"
            class="open-topbar-menu-button"
            [attr.aria-label]="'COMMON.LAYOUT.TOP_BAR_MENU' | translate"
            [attr.aria-expanded]="showTopbarMenu"
            [attr.aria-haspopup]="'menu'"
            [attr.aria-controls]="'topbar-menu'">
            <mat-icon
              *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'"
              fontSet="material-icons-outlined"
              class="open-topbar-menu-icon"
              >person
            </mat-icon>
            <mat-icon
              *ngIf="deviceInfo.deviceTypeDetected !== 'DESKTOP'"
              fontSet="material-icons-outlined"
              class="open-topbar-menu-icon"
              >settings
            </mat-icon>
          </button>
        </div>
      </div>
      <div
        *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP' && showProgressBar"
        class="row row-progress-bar"
        role="progressbar"
        [attr.aria-label]="'COMMON.LAYOUT.PROGRESSBAR' | translate"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="100"
        [attr.aria-valuenow]="progressPercentage"
        [attr.aria-valuetext]="'COMMON.LAYOUT.SURVEY_COMPLETION' | translate: { percent: progressPercentage }">
        <mat-progress-bar mode="determinate" [value]="progressPercentage" [attr.aria-hidden]="true"></mat-progress-bar>
      </div>
    </div>
    <div *ngIf="infoBarState.show" class="top-info-bar" [ngClass]="infoBarState.type" (click)="infoBarClicked()">
      <ng-container *ngIf="infoBarState.type === 'logout-warning'; else normalInfo">
        <span
          class="text-content"
          [innerHTML]="'TOP_BAR.LOGOUT_WARNING' | translate: { timeLeft: infoBarState.timeLeft }">
        </span>
      </ng-container>

      <ng-template #normalInfo>
        <mat-icon
          *ngIf="infoBarState.type === 'info' && deviceInfo.deviceTypeDetected !== 'PHONE'"
          class="icon-info"
          svgIcon="info-outline"></mat-icon>
        <div class="text-content" [innerHTML]="infoBarState.message | translate: infoBarState.translateParams"></div>
        <!-- <mat-icon *ngIf="infoBarState.action === 'PAGE_REFRESH'"
                  (click)="infoBarClicked()"
                  class="icon-refresh"
                  svgIcon="refresh">
        </mat-icon> -->
      </ng-template>
    </div>

    <app-notifications
      *ngIf="showNotifications"
      id="notifications-panel"
      role="dialog"
      (closeNotifications)="showNotifications = false">
    </app-notifications>

    <app-topbar-menu *ngIf="showTopbarMenu" id="topbar-menu" role="menu" (closeTopbarMenu)="showTopbarMenu = false">
    </app-topbar-menu>

    <main
      id="main-content"
      class="content"
      #contentWrapper
      [class.with-bottom-bar]="showBottomFixedBar"
      [class.with-progress-indicator]="showProgressBar"
      [class.with-info-bar]="infoBarState.show">
      <div
        *ngIf="deviceInfo.deviceTypeDetected !== 'DESKTOP' && showProgressBar"
        class="mobile-percentages-container"
        role="progressbar"
        [attr.aria-label]="'COMMON.LAYOUT.PROGRESSBAR' | translate"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="100"
        [attr.aria-valuenow]="progressPercentage"
        [attr.aria-valuetext]="'COMMON.LAYOUT.SURVEY_COMPLETION' | translate: { percent: progressPercentage }">
        <mat-progress-bar mode="determinate" [value]="progressPercentage" [attr.aria-hidden]="true"></mat-progress-bar>
        <span class="progress-percent-text" [attr.aria-hidden]="true">{{ progressPercentage }} %</span>
      </div>

      <router-outlet></router-outlet>

      <!-- Foreinger uses app-chat -->
      <ng-container *ngIf="isForeigner || isEmployer">
        <app-chat-desktop *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'"></app-chat-desktop>
        <app-chat-mobile-button *ngIf="deviceInfo.deviceTypeDetected !== 'DESKTOP'"></app-chat-mobile-button>
      </ng-container>

      <!-- Employees/admins use support-chat/private-convos -->
      <ng-container *ngIf="userShouldSeeChatsList">
        <app-chats-wrapper-desktop *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'"></app-chats-wrapper-desktop>
        <app-chats-wrapper-mobile *ngIf="deviceInfo.deviceTypeDetected !== 'DESKTOP'"></app-chats-wrapper-mobile>
      </ng-container>
    </main>
  </div>
</div>
